// extracted by mini-css-extract-plugin
export default {"DisabledSectionBadge":"DisabledSectionBadge3SHhUBwyqGan"};